
let clickEvent = {}

const storeClickEvent = (e) => {
    clickEvent.clientX = e.clientX;
    clickEvent.clientY = e.clientY;
}

const clearClickEvent = () => {
    clickEvent = {};
}

export {
    storeClickEvent,
    clearClickEvent,
    clickEvent,
}
